import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import InvestorsPage from "./pages/InvestorsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/inversores" element={<InvestorsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
